import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BillingAlerts = ({ alerts, onRefresh }) => {
  const getAlertIcon = (type) => {
    const icons = {
      error: 'AlertCircle',
      warning: 'AlertTriangle',
      info: 'Info',
      success: 'CheckCircle'
    };
    return icons?.[type] || 'Info';
  };

  const getAlertColor = (type) => {
    const colors = {
      error: 'bg-destructive/10 border-destructive text-destructive',
      warning: 'bg-warning/10 border-warning text-warning',
      info: 'bg-primary/10 border-primary text-primary',
      success: 'bg-success/10 border-success text-success'
    };
    return colors?.[type] || 'bg-muted border-border text-foreground';
  };

  const getPriorityBadge = (priority) => {
    const badges = {
      critical: 'bg-destructive text-destructive-foreground',
      high: 'bg-warning text-warning-foreground',
      medium: 'bg-primary text-primary-foreground',
      low: 'bg-muted text-muted-foreground'
    };
    return badges?.[priority] || 'bg-muted text-muted-foreground';
  };

  if (!alerts || alerts?.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="Bell" size={20} color="var(--color-primary)" />
          Billing Alerts
        </h2>
        <Button onClick={onRefresh} variant="ghost" size="sm">
          <Icon name="RefreshCw" size={16} />
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            className={`p-4 rounded-lg border-2 ${getAlertColor(alert?.type)}`}
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name={getAlertIcon(alert?.type)} size={20} />
                <h3 className="font-semibold">{alert?.title}</h3>
              </div>
              <span className={`text-xs px-2 py-1 rounded-full font-medium ${getPriorityBadge(alert?.priority)}`}>
                {alert?.priority}
              </span>
            </div>
            <p className="text-sm mb-3">{alert?.message}</p>
            {alert?.action && (
              <Button variant="outline" size="sm" fullWidth>
                {alert?.action}
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillingAlerts;